import dayjs from 'dayjs';

// Worked time on Project Dues, shown the way the Attendance page shows it (views/user/EmployeeServices/Attendance/TopSection.jsx):
//   still in    "Working since 09:30 AM"        and a live  HH:MM:SS  that ticks every second
//   punched out "09:30 AM - 06:15 PM"           and the finished  HH:MM:SS  (green)
//   no punch    "Not punched in yet"
// The server (project_dues_dashboard.controller.js getProjectDuesWorked) decides what each person's state is and whether the
// viewer may see it at all; this file only formats. Punch times arrive as the database's wall-clock text ("2026-10-12 09:30:00") and
// are parsed by dayjs in the browser, exactly like the Attendance page does.

export const WORKED_URL = 'warning-dashboard/project-dues-worked';

export const workedUrl = (userIds) => `${WORKED_URL}?userIds=${[...new Set(userIds)].filter((n) => Number.isInteger(Number(n)) && Number(n) > 0).join(',')}`;

// seconds -> "08:45:12" (hours can pass 24 only if someone never punched out; it still reads correctly)
export const formatDuration = (seconds) => {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const hh = String(Math.floor(s / 3600)).padStart(2, '0');
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const ss = String(s % 60).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
};

export const clock = (ts) => (ts ? dayjs(ts).format('hh:mm A') : '');

// seconds since the first punch-in, never negative (a clock a little behind the server must not show -00:00:03)
export const elapsedSince = (firstIn, nowMs = Date.now()) => {
  const start = dayjs(firstIn).valueOf();
  return Number.isFinite(start) ? Math.max(0, Math.floor((nowMs - start) / 1000)) : 0;
};

export const HIDDEN_TEXT = 'Attendance is visible only to the person, the people they report to, and HR';

// the small line above the time
export const captionFor = (worked) => {
  if (!worked) return '';
  if (worked.state === 'working') return `Working since ${clock(worked.firstIn)}`;
  if (worked.state === 'done') return `${clock(worked.firstIn)} - ${clock(worked.lastOut)}`;
  return '';
};

// one plain text for a CSV cell (a live timer has no fixed value, so a person still working reads "Working since ...")
export const workedCsv = (worked) => {
  if (!worked) return '';
  switch (worked.state) {
    case 'done': return `${formatDuration(worked.workedSeconds)} (${captionFor(worked)})`;
    case 'working': return captionFor(worked);
    case 'not_in': return 'Not punched in yet';
    case 'no_biometric_id': return 'No biometric ID';
    case 'hidden': return 'Not shown';
    default: return '';
  }
};
